import axios from 'axios'
import jwtDecode from 'jwt-decode'
import userService from './userapi'
const baseUrl = '/api/social/'

const refreshTheToken = async () => {
    console.log("Refreshing the token")
    return userService.regenerateToken().then(x => {
      console.log("FOUND REFRESH Private")
      const {accessToken} = x
      return accessToken
    })
}

const checkAuthorization = async (token) => {
    console.log("Checking authorization")
    if(token){
        let {exp} = jwtDecode(token)
        let dateNow = new Date();
        if(exp < dateNow.getTime()/1000) {
            try{
                const accessT = await refreshTheToken()
                console.log("from private route", accessT)
                if (accessT) {
                    console.log("retried to fetch refresh token successfully", accessT)
                    return accessT
                }else{
                    return null
                }
            }catch(err){
                console.error("problem with refresh token, sign in again ")
                return null
            }
        }else{
            console.log("Not access expired")
            return token
        }
    }else{
        //console.log("in the false")
        return null
    }
}

const uploadSocialImg = async (accessToken,file) => {
    const data = new FormData();
    console.log("the file", file)
    console.log("social token", accessToken)
    data.append("image", file)
    let t = await checkAuthorization(accessToken)
    
    const req = axios.post(`${baseUrl}socialimage`, data, {
        headers: {
            "authorization" : `Bearer ${t}`
        }
    })
    return req.then(req => req)
}

const uploadSocialData = async (accessToken,data) => {
    
    let t = await checkAuthorization(accessToken)
    
    const req = axios.post(`${baseUrl}socialfeedupload`, data, {
        headers: {
            "authorization" : `Bearer ${t}`
        }
    })
    return req.then(req => req)
}


const getCommentsForPost = async (accessToken, id) => {
    
    let t = await checkAuthorization(accessToken)
    
    const req = axios.get(`${baseUrl}socialpostcomments/${id}`, {
        headers: {
            "authorization" : `Bearer ${t}`
        }
    })
    return req.then(req => req)
}

const uploadSocialComment = async (accessToken,data) => {
    let t = await checkAuthorization(accessToken)
    const req = axios.post(`${baseUrl}socialfeedcommentupload`, data, {
        headers: {
            "authorization" : `Bearer ${t}`
        }
    })
    return req.then(req => req)
}

const uploadSocialPostLike = async (accessToken, hasLiked) => {
    console.log("uploading ilike", hasLiked)
    let t = await checkAuthorization(accessToken)
    const req = axios.post(`${baseUrl}socialfeedlikeupdate`,hasLiked, {
        headers: {
            "authorization" : `Bearer ${t}`
        }
    })
    return req.then(req => req)
}


const getSocialContent = async (accessToken) => {
    
    let t = await checkAuthorization(accessToken)
    
    const req = axios.get(`${baseUrl}socialfeedcontent`, {
        headers: {
            "authorization" : `Bearer ${t}`
        }
    })
    return req.then(req => req.data)
}

const getSocialUserContent = async (accessToken) => {
    
    let t = await checkAuthorization(accessToken)
    
    const req = axios.get(`${baseUrl}personalsocialcontent`, {
        headers: {
            "authorization" : `Bearer ${t}`
        }
    })
    return req.then(req => req.data)
}


export default {
    uploadSocialImg : uploadSocialImg,
    uploadSocialData : uploadSocialData,
    getSocialContent : getSocialContent,
    getSocialUserContent : getSocialUserContent,
    uploadSocialComment : uploadSocialComment,
    getCommentsForPost : getCommentsForPost,
    uploadSocialPostLike : uploadSocialPostLike

}